import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const hash = window.location.hash.slice(1)
    
    // Check if this element should show success message based on hash
    if (hash && this.shouldShowSuccessMessage(hash)) {
      this.showSuccessMessage(hash)
      
      // Clean up URL hash
      const url = window.location.href.split('#')[0]
      history.replaceState(null, '', url)
    }
  }

  shouldShowSuccessMessage(hash) {
    // Exact match (e.g., "time_log_123")
    if (this.element.id === hash) {
      return true
    }
    
    // Field-specific match (e.g., "time_log_123_start_time")
    if (hash.startsWith(this.element.id + '_')) {
      return true
    }
    
    return false
  }

  showSuccessMessage(hash) {
    // Extract field name from hash if present (e.g., "time_log_123_start_time" -> "start_time")
    const fieldName = hash.startsWith(this.element.id + '_') 
      ? hash.substring(this.element.id.length + 1) 
      : null
    
    // Find the target cell for the message
    let targetCell = null
    
    if (fieldName) {
      // Look for the specific field controller
      targetCell = this.element.querySelector(`[data-inline-edit-field-value="${fieldName}"]`)
    }
    
    if (!targetCell) {
      // Fallback to first editable cell
      targetCell = this.element.querySelector('[data-controller*="inline-edit"]')
    }
    
    if (!targetCell) {
      console.warn('No editable cell found for success message')
      return
    }
    
    // Create and show the success message
    this.createSuccessMessage(targetCell)
  }

  createSuccessMessage(targetCell) {
    const message = document.createElement('div')
    message.className = 'text-xs text-green-600 mt-1'
    message.textContent = 'Updated!'
    message.style.opacity = '0'
    message.style.transition = 'opacity 0.3s ease'
    message.style.fontWeight = 'normal'
    message.style.fontSize = '0.75rem'
    message.style.lineHeight = '1rem'
    
    // Insert the message after the display element
    const displayElement = targetCell.querySelector('[data-inline-edit-target="display"]')
    if (displayElement) {
      displayElement.parentNode.insertBefore(message, displayElement.nextSibling)
    } else {
      targetCell.appendChild(message)
    }
    
    // Animate the message
    this.animateMessage(message)
  }

  animateMessage(message) {
    // Fade in
    setTimeout(() => {
      message.style.opacity = '1'
    }, 10)
    
    // Fade out and remove after 2 seconds
    setTimeout(() => {
      message.style.opacity = '0'
      setTimeout(() => {
        if (message.parentNode) {
          message.parentNode.removeChild(message)
        }
      }, 300)
    }, 2000)
  }
} 